import type { GridColDef } from '@mui/x-data-grid';
import type { FacebookPage } from '../types';
import { CellContainer, CellTypography } from '../components/AccountsGrid.styles';
import { useCallback, useMemo } from 'react';
import { IconButton, Typography } from '@mui/material';
import { ArrowUpward } from '@mui/icons-material';
import { useListParams } from 'hooks';

const columnsAdditionalOptions = {
  disableColumnFilter: true,
  disableColumnMenu: true,
};

export const useFacebookPagesColumns = (): GridColDef<FacebookPage>[] => {
  const { desc, setDesc, setOrderBy } = useListParams();

  const handleOrderBy = useCallback(() => {
    setDesc(!desc);
    setOrderBy('name');
  }, [desc, setDesc, setOrderBy]);

  return useMemo(
    () => [
      {
        field: 'facebook_page_name',
        headerName: 'Facebook page name',
        flex: 1,
        minWidth: 200,
        sortable: false,
        ...columnsAdditionalOptions,
        renderHeader: () => {
          return (
            <CellContainer sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant={'subtitle2'}>Facebook page name</Typography>
              <IconButton
                sx={{ p: 0.5, transform: `rotate(${desc ? 0 : 180}deg)` }}
                onClick={handleOrderBy}
              >
                <ArrowUpward sx={{ fontSize: 16 }} />
              </IconButton>
            </CellContainer>
          );
        },
        renderCell: ({ row }) => (
          <CellContainer>
            <CellTypography variant={'body2'}>{row.facebook_page_name}</CellTypography>
          </CellContainer>
        ),
      },
      {
        field: 'facebook_page_id',
        headerName: 'Facebook page ID',
        flex: 1,
        minWidth: 200,
        sortable: false,
        ...columnsAdditionalOptions,
        renderCell: ({ row }) => (
          <CellContainer>
            <CellTypography variant={'body2'}>{row.facebook_page_id}</CellTypography>
          </CellContainer>
        ),
      },
      {
        field: 'instagram_page_id',
        headerName: 'Instagram account ID',
        flex: 1,
        minWidth: 200,
        sortable: false,
        ...columnsAdditionalOptions,
        renderCell: ({ row }) => (
          <CellContainer>
            <CellTypography variant={'body2'}>{row.instagram_page_id}</CellTypography>
          </CellContainer>
        ),
      },
    ],
    [desc, handleOrderBy],
  );
};
